import { call, put, select } from 'redux-saga/effects';

import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { selectSpaceInfoItem } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';

import { requestFailed } from '../../app/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import { IDataSourceBase } from '../../datasource/models/IDataSourceInfo';
import { ChangeRemoteExtractRefreshAction } from '../actions/ChangeRemoteExtractRefreshAction';
import { EditRemoteRefreshScheduleAction } from '../components/editRemoteRefresh/EditRemoteRefreshScheduleAction';
import { RefreshPropertyHelper } from '../helpers/RefreshPropertyHelper';
import { IRemoteRefreshScheduleInfo } from '../models/IRemoteRefreshScheduleInfo';

export function* handleChangeRemoteExtractRefreshAction(action: ChangeRemoteExtractRefreshAction) {
  try {
    const datasource: IDataSourceBase = yield select(selectSpaceInfoItem);
    yield call(executeChangeRemoteExtractRefreshAction, datasource, action.schedule);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeChangeRemoteExtractRefreshAction(
  datasource: IDataSourceBase,
  item: IRemoteRefreshScheduleInfo
) {
  const availableTypes = RefreshPropertyHelper.getAvailableRefreshTypes(datasource);
  return EditRemoteRefreshScheduleAction.execute(datasource, item, availableTypes);
}
